import { Link } from "react-router-dom";
import { MapPin, CalendarBlank, Users, ArrowRight } from "@phosphor-icons/react";
import { fmtDate, money } from "@/lib/api";

export const EventCard = ({ e, i = 0 }) => {
  const tz = e.city?.timezone;
  const sale = (e.price_tiers || []).filter((t) => t.on_sale);
  const low = sale.length ? Math.min(...sale.map((t) => t.price_cents)) : 0;
  const closed = !e.registration?.open;
  const pct = Math.round(100 * (1 - e.seats_left / Math.max(1, e.capacity)));
  return (
    <Link
      to={`/events/${e.slug}`}
      data-testid={`event-card-${e.slug}`}
      className="rise group block panel p-5 transition-transform transition-colors duration-200 hover:-translate-y-1 hover:border-[#E0A21B]"
      style={{ animationDelay: `${i * 60}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.18em] text-[#475569]">
            <MapPin size={14} weight="fill" className="text-[#E0A21B]" /> {e.city?.name}, {e.city?.province}
          </div>
          <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight text-[#0B1B33]">{e.title}</h3>
        </div>
        <ArrowRight size={22} className="mt-1 shrink-0 text-[#0B1B33]/40 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-[#E0A21B]" />
      </div>
      <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm text-[#475569]">
        <span className="flex items-center gap-1.5"><CalendarBlank size={16} /> {fmtDate(e.start_at, tz)} – {fmtDate(e.end_at, tz, { year: undefined })}</span>
        <span className="flex items-center gap-1.5"><Users size={16} /> <span className="font-mono-num">{e.seats_left}</span> seats left</span>
      </div>
      <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-[#F4F6FA]">
        <div className="h-full bg-[#1E8E5A]" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-4 flex items-baseline justify-between">
        {closed ? (
          <span className="rounded-full bg-[#E2E8F0] px-3 py-1 text-xs font-bold uppercase text-[#475569]" data-testid="event-card-closed">
            Coming soon – {e.registration?.opens_at ? `registration opens ${fmtDate(e.registration.opens_at, tz)}` : "registration closed"}
          </span>
        ) : low ? (
          <>
            <span className="text-xs uppercase tracking-wider text-[#475569]">From</span>
            <span className="font-mono-num text-lg font-semibold">{money(low)} <span className="text-xs text-[#475569]">plus applicable taxes</span></span>
          </>
        ) : <span className="text-xs text-[#475569]">Tickets not on sale yet</span>}
      </div>
    </Link>
  );
};
